import { Message, MessageBox, Loading } from "element-ui";
import { getToken } from "@/utils/auth";
import axios from "axios";
export default {
  PrefixZero(num, n) {
    return (Array(n).join(0) + num).slice(-n);
  },
  // Excel文件验证
  noXlsx(file) {
    let suffix = file.substr(file.lastIndexOf("."));
    if (".xls" != suffix && ".xlsx" != suffix) {
      Message.warning("选择Excel格式的文件导入！");
      return true;
    } else {
      return false;
    }
  },
  // confirm提示框
  confirm(text, type) {
    return new Promise((resolve, reject) => {
      MessageBox.confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type || ""
      })
        .then(() => resolve())
        .catch(() => {});
    });
  },
  //递归遍历树形json数据
  findPathByLeafId(arr, id) {
    arr.forEach(item => {
      //利用foreach循环遍历
      console.log(item);
      if (item.id == id) {
        //判断递归结束条件
        return item;
      } else if (item.children) {
        //判断chlidren是否有数据
        {
          if (item.children.length > 0) {
            this.findPathByLeafId(item.children, id);
          }
        }
      }
    });
  },
  //loading
  loading(text) {
    return Loading.service({
      lock: true,
      text: text || "加载中...",
      spinner: "el-icon-loading"
    });
  },
  // 获取文件
  getObjUrl(url, params) {
    axios
      .get(url, {
        params: params,
        headers: {
          Authorization: getToken()
        },
        responseType: "blob" //告诉服务器我们需要的响应格式
      })
      .then(res => {
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel" //将会被放入到blob中的数组内容的MIME类型
        });
        let objectUrl = URL.createObjectURL(blob); //生成一个url
        console.log(objectUrl);
        window.location.href = objectUrl; //浏览器打开这个url
      })
      .catch(err => {
        console.log(err);
      });
  },
  /**
   * 函数防抖
   * @param fn 需要防抖的函数
   * @param gapTime 时间
   */
  throttle(fn, gapTime) {
    if (gapTime == null || gapTime == undefined) {
      gapTime = 1500;
    }
    let _lastTime = null;
    return function() {
      let _nowTime = +new Date();
      if (_nowTime - _lastTime > gapTime || !_lastTime) {
        fn.apply(this, arguments);
        _lastTime = _nowTime;
      }
    };
  }
};
